
import React from "react";
import { Handle, Position } from '@xyflow/react';
import { UserCircle } from "lucide-react";

export const CustomNode = ({
  data,
  selected
}: {
  data: any;
  selected?: boolean;
}) => {
  return (
    <div className="text-center">
      <Handle 
        type="target" 
        position={Position.Top} 
        style={{
          width: '15px',
          height: '15px',
          background: '#555'
        }} 
      />
      <Handle 
        type="source" 
        position={Position.Bottom} 
        style={{
          width: '15px',
          height: '15px',
          background: '#555'
        }} 
      />
      <UserCircle className="w-8 h-8 mx-auto mb-2" />
      <div className="font-medium text-black">{data.name}</div>
      <div className="text-sm text-black">{data.title}</div>
    </div>
  );
};
